import { useCallback, useEffect, useState } from 'react';
import { CarrionService } from '../../services/carrion/carrionService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage carrion status data fetching and transformation.
* ES: Hook para gestionar la obtención y transformación de datos del estado de carroñas.
----------------------------------------------------------------------------------------*/

const useCarrionStatus = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999, 
        filter_filters: { ...initialFilters } 
    });

    const fetchCarrionStatus = useCallback(async () => {
        try {
            const service = new CarrionService();
            const response = await service.listForSelectStatus({ limit: 999999 });
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; color: string; }) => ({
                    value: data.id,
                    label: data.name,
                    color: data.color,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching statuses:', error);
        }
    }, []);

    useEffect(() => {
        fetchCarrionStatus();
    }, []);

    const getCarrionStatusList = () => {
        return data;
    };

    return { fetchCarrionStatus, getCarrionStatusList };
}

export default useCarrionStatus;